import errorTrackerV2 from "./Utils/ErrorTrackerV2";
// import { shouldBypassValidation } from "../../Utils/validationPolicy";
// import { auth } from "../../../../../backend/firebaseConfig";

// ---- VALIDATION (Section 10) - same pattern as Sections 1/2/3/9 ----
export const validateSection10 = ({
  formData,
  setErrors,
  onValidationStatusChange,
}) => {
  const f = formData;
  const newErrors = {};

  // If data is null, all required fields are missing
  if (formData === null || formData === undefined) {
    newErrors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section10", newErrors);
    onValidationStatusChange?.(false);
    return false;
  }

  const req = (cond, key, msg = "This field is required.") => {
    if (cond) newErrors[key] = msg;
  };

  // Yes/No required
  req(f.unemployedOrClaimedBenefit == null, "unemployedOrClaimedBenefit");

  // If YES → validate all nested fields
  if (f.unemployedOrClaimedBenefit === true) {
    (f.details || []).forEach((section, index) => {
      req(!section?.dwpOfficeAddress?.trim(), `dwpOfficeAddress-${index}`);
      req(!section?.dwpPostCode?.trim(), `dwpPostCode-${index}`);
      req(!section?.name?.trim(), `name-${index}`);
      req(!section?.currentAddress?.trim(), `currentAddress-${index}`);
      req(!section?.postcode?.trim(), `postcode-${index}`);

      req(!section?.benefitClaimed?.trim(), `benefitClaimed-${index}`);

      req(
        !section?.nationalInsuranceNumber?.trim(),
        `nationalInsuranceNumber-${index}`,
      );

      req(!section?.dateOfBirth, `dateOfBirth-${index}`);
      req(!section?.from, `from-${index}`);
      req(!section?.to, `to-${index}`);

      req(!section?.areasOfConcern?.trim(), `areasOfConcern-${index}`);

      // Date at the bottom required
      req(!section?.date, `date-${index}`);

      // Officer signature currently NOT required (kept as your original behaviour)
      // req(!section?.officerSignature, `officerSignature-${index}`);

      // Advisor signature required
      // req(!section?.advisorSignature, `advisorSignature-${index}`);

      // Table rows required
      (section?.benefitDetails || []).forEach((benefit, benefitIndex) => {
        req(!benefit?.from, `from-${index}-${benefitIndex}`);
        req(!benefit?.to, `to-${index}-${benefitIndex}`);
        req(
          !benefit?.benefitClaimed?.trim(),
          `benefitClaimed-${index}-${benefitIndex}`,
        );
      });
    });
  }

  setErrors(newErrors);
  // console.log("Section 10 validation errors:", newErrors);
  errorTrackerV2.setSectionErrors("section10", newErrors);


  const ok = Object.keys(newErrors).length === 0;
  onValidationStatusChange?.(ok);

  return ok;
};
